import { render, staticRenderFns } from "./FlowRecordPanelItem.vue?vue&type=template&id=49b21357&"
import script from "./FlowRecordPanelItem.vue?vue&type=script&lang=js&"
export * from "./FlowRecordPanelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports